module.exports = __webpack_public_path__ + "assets/img/IMG022.f5e16bfa.png";